module.exports = __webpack_public_path__ + "cf0b655166b18a56349665736f581553.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/meta_2022_chart.png
// module id = 1691
// module chunks = 0